import React from 'react';
import styles from './Flares.module.scss';
import defaultBackground from '../../assets/images/flares/background_1.png';
import flaresToken from '../../assets/images/flares/flares_token_1.png';
import WarToken from '../../assets/images/war_token.png';
import { formatNumber } from '../../shared/helpers';
import { MASCOT_TYPES } from '../../shared/constants';

const Flares = ({
    OldPrice,
    NewPrice,
    OfferId,
    Type,
    selectOfferById,
    currency,
    amount,
    config,
    WarTokens,
    MascotType

}) => {
    const getDynamicBackground = (mascotType) => {
        // If MascotType is None (0) or undefined, use default background
        if (!mascotType || mascotType === MASCOT_TYPES.None) {
            return defaultBackground;
        }

        try {
            return require(`../../assets/images/flares/background_${mascotType}.png`).default;
        } catch (error) {
            return defaultBackground;
        }
    };

    const getDynamicFlaresTokenImage= (mascotType) => {
        // If MascotType is None (0) or undefined, use default flaresToken
        if (!mascotType || mascotType === MASCOT_TYPES.None) {
            return flaresToken;
        }

        try {
            return require(`../../assets/images/flares/flares_token_${mascotType}.png`).default;
        } catch (error) {
            return flaresToken;
        }
    };

    const backgroundImage = getDynamicBackground(MascotType);
    const flaresTokenImage = getDynamicFlaresTokenImage(MascotType);

    return (
        <div className={`${styles.wrapper} ${styles.fortuneEventWrapper}`} onClick={() => selectOfferById(OfferId, Type, flaresToken, config.flaresTitle, amount, Type, null, backgroundImage)}>
            <img src={backgroundImage} alt={''} className={styles.background} />
            <div className={styles.name}>{config.flaresTitle}</div>
            <div className={styles.quantity}>{amount}</div>
            <img src={flaresTokenImage} alt={''} className={styles.fortuneImage} />
            <div className={styles.pricesWrapper}>
                <div className={styles.oldPrice}>
                    {OldPrice.toFixed(2)} {currency}
                    <div className={'stroke'}></div>
                </div>
                <div className={styles.newPrice}>{NewPrice.toFixed(2)} {currency}</div>
            </div>
            <div className="warTokensWrapper">
                <div>+&nbsp;</div>
                <div>{formatNumber(WarTokens)}</div>
                <img className="warTokenImg" src={WarToken} alt='' />
            </div>
        </div>
    );
};

export default Flares;
